<template>
  <span>{{ hour }}{{ minute }}:{{ second }}</span>
</template>

<script>
export default {
  props: ["duration"],
  computed: {
    hour() {
      let h = parseInt(this.duration / 3600);
      if (h === 0) {
        return "";
      } else {
        return h >= 10 ? h + ":" : "0" + h + ":";
      }
    },
    minute() {
      let m = parseInt((this.duration % 3600) / 60);
      return m >= 10 ? m : "0" + m;
    },
    second() {
      let s = (this.duration % 3600) % 60;
      return s >= 10 ? s : "0" + s;
    },
  },
};
</script>
